"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
const AcquisitionScore_1 = tslib_1.__importDefault(require("./enums/AcquisitionScore"));
const ProfileQuery_1 = tslib_1.__importDefault(require("./ProfileQuery"));
const CustomerJourneyPhase_1 = tslib_1.__importDefault(require("./enums/CustomerJourneyPhase"));
const ChurnScore_1 = tslib_1.__importDefault(require("./enums/ChurnScore"));
const GridOperator_1 = tslib_1.__importDefault(require("./enums/GridOperator"));
/**
 * A Profile query base result as returned by the API
 */
class Profile extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => ProfileQuery_1.default),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", ProfileQuery_1.default)
], Profile.prototype, "query", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'profile_id' }),
    (0, base_models_1.Docs)({ example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7', description: 'Profile identifier' }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(AcquisitionScore_1.default)),
    (0, class_transformer_1.Expose)({ name: 'acquisition_score' }),
    (0, base_models_1.Docs)({ example: AcquisitionScore_1.default.MEDIUM, description: 'How much the acquisition is worth' }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "acquisitionScore", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({ example: base_models_1.Brand.ESSENT, description: 'Profile Brand' }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'True if the customer has opted in for a loyalty programme' }),
    tslib_1.__metadata("design:type", Boolean)
], Profile.prototype, "loyalty", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'True if the customer provides electricity feed-in to the grid' }),
    tslib_1.__metadata("design:type", Boolean)
], Profile.prototype, "teruglevering", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(CustomerJourneyPhase_1.default)),
    (0, class_transformer_1.Expose)({ name: 'customer_journey_phase' }),
    (0, base_models_1.Docs)({ example: 'new_customer', description: 'The phase of the customer in BAC' }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "customerJourneyPhase", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(ChurnScore_1.default)),
    (0, class_transformer_1.Expose)({ name: 'churn_score' }),
    (0, base_models_1.Docs)({ example: 'very_low', description: 'The risk the customer will leave' }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "churnScore", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'grid_operator' }),
    (0, base_models_1.Docs)({
        example: 'stedin',
        description: 'Returns the approximate operator if an address is know for the profile. Returns `multiple` if gas and electricity operator differ from each other.',
    }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "gridOperator", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'grid_operator_gas' }),
    (0, base_models_1.Docs)({
        example: 'stedin',
        description: 'Returns the approximate gas operator if an address is know for the profile',
    }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "gridOperatorGas", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'grid_operator_electricity' }),
    (0, base_models_1.Docs)({
        example: 'stedin',
        description: 'Returns the electricity gas operator if an address is know for the profile',
    }),
    tslib_1.__metadata("design:type", String)
], Profile.prototype, "gridOperatorElectricity", void 0);
exports.default = Profile;
